export const buildInfo = {
  "version": "0.3.0",
  "commit": "b4bec0b",
  "branch": "main",
  "builtAt": "2026-05-09T16:06:36.502Z",
  "repositoryUrl": "https://github.com/baditaflorin/complete-gardener-planner",
  "paypalUrl": "https://www.paypal.com/paypalme/florinbadita",
  "pagesUrl": "https://baditaflorin.github.io/complete-gardener-planner/"
} as const
